import { render, staticRenderFns } from "./FeedAndMentionsShortcutsModal.vue?vue&type=template&id=8ab58c5a&"
import script from "./FeedAndMentionsShortcutsModal.vue?vue&type=script&lang=js&"
export * from "./FeedAndMentionsShortcutsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports